/**
 * Custom Rectangle Mode - 2 clicks to define opposite corners
 * Simple and intuitive for MapLibre
 */

// @ts-nocheck
const DrawRectangleMode: any = {};

DrawRectangleMode.onSetup = function() {
  const rectangle = this.newFeature({
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [[]],
    },
  });

  this.addFeature(rectangle);
  this.clearSelectedFeatures();
  this.updateUIClasses({ mouse: 'add' });
  this.setActionableState({ trash: true });

  // Set crosshair cursor
  this.map.getCanvas().style.cursor = 'crosshair';

  console.log('🔷 Rectangle mode setup - Click 2 opposite corners');

  return {
    rectangle,
    corner1: null,
    corner2: null,
  };
};

DrawRectangleMode.onClick = function(state: any, e: any) {
  console.log('🔷 Click detected');

  // First click - store first corner
  if (!state.corner1) {
    state.corner1 = [e.lngLat.lng, e.lngLat.lat];
    console.log('📍 Corner 1:', state.corner1);

    // Show a temporary point
    const tempCoords = [[state.corner1, state.corner1, state.corner1, state.corner1, state.corner1]];
    state.rectangle.incomingCoords(tempCoords);

    return;
  }

  // Second click - store second corner and complete
  if (!state.corner2) {
    state.corner2 = [e.lngLat.lng, e.lngLat.lat];
    console.log('📍 Corner 2:', state.corner2);

    // Create rectangle from two opposite corners
    const minLng = Math.min(state.corner1[0], state.corner2[0]);
    const maxLng = Math.max(state.corner1[0], state.corner2[0]);
    const minLat = Math.min(state.corner1[1], state.corner2[1]);
    const maxLat = Math.max(state.corner1[1], state.corner2[1]);

    const rectangleCoords = [
      [
        [minLng, minLat],  // SW
        [maxLng, minLat],  // SE
        [maxLng, maxLat],  // NE
        [minLng, maxLat],  // NW
        [minLng, minLat],  // close ring
      ],
    ];

    state.rectangle.incomingCoords(rectangleCoords);

    console.log('✅ Rectangle completed:', rectangleCoords);
    console.log('📦 Rectangle feature ID:', state.rectangle.id);

    // Verificar cuántos features hay antes de disparar el evento
    const allFeatures = this.getSelected();
    console.log('📊 Features en Draw antes de create:', allFeatures);

    // Fire create event
    console.log('🔥 Disparando draw.create event');
    this.map.fire('draw.create', {
      features: [state.rectangle.toGeoJSON()],
    });

    // Switch to custom direct_select_rectangle mode for constrained vertex editing
    console.log('🔄 Cambiando a modo direct_select_rectangle con featureId:', state.rectangle.id);
    this.changeMode('direct_select_rectangle', { featureId: state.rectangle.id });
  }
};

DrawRectangleMode.onMouseMove = function(state: any, e: any) {
  // Keep crosshair cursor
  this.map.getCanvas().style.cursor = 'crosshair';

  // Show preview rectangle if first corner is set
  if (state.corner1 && !state.corner2) {
    const currentPoint = [e.lngLat.lng, e.lngLat.lat];

    const minLng = Math.min(state.corner1[0], currentPoint[0]);
    const maxLng = Math.max(state.corner1[0], currentPoint[0]);
    const minLat = Math.min(state.corner1[1], currentPoint[1]);
    const maxLat = Math.max(state.corner1[1], currentPoint[1]);

    const previewCoords = [
      [
        [minLng, minLat],
        [maxLng, minLat],
        [maxLng, maxLat],
        [minLng, maxLat],
        [minLng, minLat],
      ],
    ];

    state.rectangle.incomingCoords(previewCoords);
  }
};

DrawRectangleMode.onStop = function(state: any) {
  console.log('🛑 Rectangle mode stopped');

  this.updateUIClasses({ mouse: 'none' });
  this.activateUIButton();

  // Reset cursor
  if (this.map && this.map.getCanvas()) {
    this.map.getCanvas().style.cursor = '';
  }

  // Clean up if not completed
  if (state.rectangle && !state.corner2) {
    console.log('🗑️ Deleting incomplete rectangle');
    this.deleteFeature([state.rectangle.id], { silent: true });
  }
};

DrawRectangleMode.toDisplayFeatures = function(state: any, geojson: any, display: any) {
  const isActivePolygon = geojson.properties.id === state.rectangle.id;
  geojson.properties.active = isActivePolygon ? 'true' : 'false';

  if (geojson.geometry.coordinates[0].length > 0) {
    return display(geojson);
  }
};

DrawRectangleMode.onTrash = function(state: any) {
  console.log('🗑️ Trash clicked');
  this.deleteFeature([state.rectangle.id], { silent: true });
  this.changeMode('simple_select');
};

DrawRectangleMode.onKeyUp = function(state: any, e: any) {
  if (e.keyCode === 27) {
    console.log('⌨️ Escape pressed');
    this.deleteFeature([state.rectangle.id], { silent: true });
    this.changeMode('simple_select');
  }
};

export default DrawRectangleMode;
